import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { EventManager } from 'src/app/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent implements OnInit, OnDestroy {
  @Input() isTotal = true;
  @Input() isSearch = true;
  @Input() isCreate = true;
  @Input() total;
  @Output() search$: EventEmitter<string> = new EventEmitter();
  subscriptions: Subscription[];
  params: any = {};
  constructor(
    public eventManager: EventManager
  ) {

  }
  ngOnInit() {
    this.subscriptions = [...[
      this.eventManager.subscribe(('add-option-search'), (res) => {
        this.addOption(res.content);
      }),
      this.eventManager.subscribe(('get-value-search'), (res) => {
        this.search();
      }),
    ]];
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
  addOption(object) {
    this.params[object.key] = object.value;
  }
  create() {
    this.eventManager.broadcast({
      name: 'create-new-item',
      content: {}
    })
  }
  search() {
    this.search$.emit(this.params);
  }
}
